import type React from 'react';
import { useEffect } from 'react';
import { Toast, useToast } from '@zillow/constellation-10';

import type { LeaseActionProps } from '../../../models/Types';
import { downloadFileFromUrl } from '../../../utils/urlUtils';
import LeaseExtension from '../../../models/LeaseExtension';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';
import { logError } from '@zg-rentals/log-error';
import { DOWNLOAD_TOAST_MESSAGES } from '../../../constants/stringConstants';
import { GetLeaseHelpButton } from '../../Widgets/GetLeaseHelpButton';

export default function DownloadLeaseExtensionPdf({ terminateActiveAction, lease }: LeaseActionProps): React.ReactNode {
  const latestExtension = lease?.latestExtension ?? null;
  const { renewalId } = useLeasingUrlParams();
  const extensionId = renewalId || latestExtension?.id || '';
  const { enqueueToast } = useToast();

  const onFileDownloadedSuccessToast = () => {
    enqueueToast(<Toast tone="success">{DOWNLOAD_TOAST_MESSAGES.LEASE_EXTENSION_SUCCESS}</Toast>);
  };

  const onFileDownloadedErrorToast = () => {
    enqueueToast(
      <Toast tone="critical" actionButton={<GetLeaseHelpButton onImpact />}>
        {DOWNLOAD_TOAST_MESSAGES.LEASE_EXTENSION_ERROR}
      </Toast>,
    );
  };

  useEffect(() => {
    downloadFileFromUrl(LeaseExtension.getPDFLink(extensionId))
      // eslint-disable-next-line promise/always-return
      .then(() => {
        onFileDownloadedSuccessToast();
        terminateActiveAction();
      })
      .catch((err) => {
        logError({ error: err, context: 'DownloadLeaseExtensionPdf - download failed' });
        onFileDownloadedErrorToast();
        terminateActiveAction();
      });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, [extensionId, terminateActiveAction]);

  return null;
}
